import * as React from "react";
import AlbumViewer, { DownloadGalleryPhotosAction } from "../AlbumViewer";
import ModalPopup from "./ModalPopup";
import Photo from "../../model/Photo";
import { createRoot } from "react-dom/client";

interface ModalAlbumViewerProps {
  portraitPhotos: Photo[];
  landscapePhotos: Photo[];
  hide: () => void;
  action: DownloadGalleryPhotosAction;
  selectedPhoto?: Photo;
}

export default class ModalAlbumViewer extends React.Component<ModalAlbumViewerProps> {
  render() {
    return (
      <ModalPopup closeModal={this.props.hide} id="modal-album-viewer" fullscreen={true}>
        <AlbumViewer {...this.props} />
      </ModalPopup>
    );
  }

  static loadComponent(elementId: string, props: ModalAlbumViewerProps) {
    const container = document.getElementById(elementId);
    const root = createRoot(container!);
    root.render(<ModalAlbumViewer {...props} />);
  }
}
